'use strict';

export var activityService = function($http, $q, configService) {

    var _config_ = null;
    var _ticketId = null;
    var batch = [];
    var BATCH_SIZE = 10;

    var post = function(ticketId, activity) {
        _ticketId = ticketId;
        
        if (batch.push(activity) >= BATCH_SIZE) {
            return this.flush();
        } else {
            return $q.when({});
        }
    };

    var flush = function() {
        if (batch.length === 0) return $q.when({});

        var tempBatch = batch;
        batch = [];
        return postActivityBatch(tempBatch);
    };

    function postActivityBatch(activityBatch) {

        return getConfig().then((config) => {
            return $http({
                method: 'POST',
                url: config.url,
                headers: {
                    'Content-Type': 'application/atom+xml;type=entry;charset=utf-8',
                    'Authorization': config.sasToken
                },
                data: activityBatch
            })
        });
    }

    function getConfig() {
        if (_config_ != null) {
            return $q.when(_config_);
        } else {
            return configService.getActivityConfig(_ticketId).then((config) => {
                _config_ = config;
                return config;
            });
        }
    }

    return {
        post: post,
        flush: flush
    };
};

activityService.$inject = [ '$http', '$q', 'configService' ];